'use strict';

wbApp.factory('compensationTransferSvc', ['$resource', '$q', '$translate', 'notificationSvc', 'repositorySvc',
    function ($resource, $q, $translate, notificationSvc, repositorySvc) {

        var CompensationTransfer = $resource('/Api/CompensationTransfer/Get', {}, {
            'query':  { method: 'GET', isArray: false },
            'update': { method: 'POST', url: '/Api/CompensationTransfer/Update' }//,
        });


        function getAsync(sourceSemesterID, destinationSemesterID) {
            return repositorySvc.get(CompensationTransfer, {
                sourceSemesterID: sourceSemesterID,
                destinationSemesterID: destinationSemesterID
            });
        }

        function changeTransferToAmendType(model, transferToAmendType) {
            _.forEach(model.items, function (item) {
                if (transferToAmendType === 1) {
                    // Pre - amends
                    if (item.transferredTimeBoundAmends) {
                        item.transferredPreAmends = item.transferredPreAmends + item.transferredTimeBoundAmends;
                        item.transferredTimeBoundAmends = 0;
                    }
                } else {
                    // Time bound amends
                    if (item.transferredPreAmends) {
                        item.transferredTimeBoundAmends = item.transferredPreAmends + item.transferredTimeBoundAmends;
                        item.transferredPreAmends = 0;
                    }
                }
                item.isPristine = false;
            });            
        }

        function changeMaximumTransferredAmends(model, maximumTransferredAmends) {
            var newValue = 0;
            _.forEach(model.items, function (item) {
                if (model.compensationTransfer.transferToAmendType === 1) {
                    // Pre - amends
                    newValue = Math.min(maximumTransferredAmends, item.availableAmends);
                    if (item.transferredPreAmends !== newValue) {
                        item.transferredPreAmends = newValue;
                        item.isPristine = false;
                    }
                } else {
                    // Time bound amends
                    newValue = Math.min(maximumTransferredAmends, item.availableAmends);
                    if (item.transferredTimeBoundAmends !== newValue) {
                        item.transferredTimeBoundAmends = newValue;
                        item.isPristine = false;
                    }
                }
            });
        }

        function changeTransferRemainingPreAmends(model, transferRemainingPreAmends) {
            initializeAmends(model);
            changeMaximumTransferredAmends(model, model.compensationTransfer.maximumTransferredAmends);
        }

        function changeTransferRemainingTimeBoundAmends(model, transferRemainingTimeBoundAmends) {
            initializeAmends(model);
            changeMaximumTransferredAmends(model, model.compensationTransfer.maximumTransferredAmends);
        }

        function createEmptyModel(sourceSemesterID) {
            return {
                isNew: true,
                compensationTransfer: {
                    sourceSemesterID: sourceSemesterID,
                    destinationSemesterID: 2
                }
            };
        }

        function initilizeModelAsync(model, destinationSemesterID) {
            var deferred = $q.defer();

            var serverData = getAsync(model.compensationTransfer.sourceSemesterID, destinationSemesterID);
            serverData.$promise.then(function (data) {
                model.items = [];
                angular.extend(model, data);
                delete model.$promise;
                delete model.$resolved;

                initializeAmends(model);

                deferred.resolve(model);
            });

            return deferred.promise;
        }

        function initializeAmends(model) {
            _.forEach(model.items, function (item) {
                item.availableAmends = item.remainingAmends;
                if (model.compensationTransfer.transferRemainingPreAmends) {
                    item.availableAmends = item.availableAmends + item.remainingPreAmends;
                }
                if (model.compensationTransfer.transferRemainingTimeBoundAmends) {
                    item.availableAmends = item.availableAmends + item.remainingTimeBoundAmends;
                }
            });
        }

        function update(data, successCallback, errorCallback) {

            function error(data) {
                if (data.errors && data.errors.length) {
                    notificationSvc.notifyError($translate.instant('TXT_ALERT_TITLE_ENTITY_SAVE_ERROR'));
                }

                if (errorCallback) {
                    errorCallback(data);
                }
            }

            return repositorySvc.update(
                CompensationTransfer,      // $resource
                null,                      // collection
                data,                      // entity
                successCallback,
                error);
        }

        return {
            createEmptyModel: createEmptyModel,
            getAsync: getAsync,
            changeTransferToAmendType: changeTransferToAmendType,
            changeMaximumTransferredAmends: changeMaximumTransferredAmends,
            initilizeModelAsync: initilizeModelAsync,
            update: update,
            changeTransferRemainingPreAmends: changeTransferRemainingPreAmends,
            changeTransferRemainingTimeBoundAmends: changeTransferRemainingTimeBoundAmends
        }
    }
]);
